<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.employees')"
                :pgIcon="'bx bx-user-pin'"
                :refs="refs"
                :pgCurrent="pgCurrent"
                :addNew="false">
            </Breadcrumb>

            <div class="row">

                <Loading
                    v-if="pgLoading">
                </Loading>

                <div class="col-12">

                    <EmployeeInfo 
                        v-if="!pgLoading"
                        :employee="row.employee">
                    </EmployeeInfo>

                    <EmployeeSheet 
                        v-if="!pgLoading"
                        :employee="row.employee">
                    </EmployeeSheet>

                </div>

            </div>


        </div>
    </div>

</template>

<script>
import iziToast from 'izitoast';

export default {
    name: 'Analytics',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        Loading: () => import('@/components/Loading.vue'),
        EmployeeInfo: () => import('@/components/EmployeeInfo.vue'),
        EmployeeSheet: () => import('@/components/EmployeeSheet.vue'),
    },
    data(){
        return {    
            // auth
            auth: {
                role: '',
                access_token: '',
            },
            row: {
                employee: {}
            },
            pgCurrent: 'Analytics',
            pgLoading: true,
            refs: 'employees',
        }
    },
    watch: {},
    mounted() {},
    created() {
        // AccessToken & Role
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }

        if(this.$route.params.id) {
            this.fetchRow();
        }
    },
    methods: {
        // fetch Row
        fetchRow() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;
                this.row.employee = res.data.row;
            })
            .catch(err => {

                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                }

            })
            .finally(() => {});
        },


        // clear Local Storage
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('avatar');
            localStorage.removeItem('username');
            localStorage.removeItem('encrypt_id');
            localStorage.removeItem('role');
        },


    },
}
</script>
